/**
 * WooCommerce Quick Buy frontend entry.
 */
import { createController } from './controller.js';
import { clearOptionsCache } from './api/product-options.js';
import { initAnalyticsBeacon } from './analytics/beacon.js';
import { initVariationSelectors } from './variation-selector.js';
import { initWishlist } from './wishlist/carousel.js';
import {
	initTiWishlistBridge,
	syncTiWishlistFromPackForms,
	debugTiWishlistReport,
	BRIDGE_VERSION,
} from './integrations/ti-wishlist.js';

(function boot() {
	if (typeof window === 'undefined' || typeof document === 'undefined') {
		return;
	}

	const controller = createController();

	function init() {
		controller.bind();
		initAnalyticsBeacon();
		initTiWishlistBridge();
		initVariationSelectors();
		syncTiWishlistFromPackForms();
		initWishlist();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	window.WCQuickBuy = {
		clearOptionsCache,
		initVariationSelectors,
		initWishlist,
		debugTiWishlist: debugTiWishlistReport,
		version: BRIDGE_VERSION,
	};
})();
